import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface IAnexoPrevisaoCompra {
  idAnexo: number;
  anexo: string;
  descricao?: string;
}

export const ObterAnexos = async (
  codLoja: number,
  codPrevisaoCompra: number,
  sequencial: number,
): Promise<IAnexoPrevisaoCompra[]> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IAnexoPrevisaoCompra[]>(`/obter-anexos`, {
      params: {
        codLoja,
        codPrevisaoCompra,
        sequencial,
        token,
      },
    });

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter os anexos para esta previsão"
    );
  }
};